/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespSimilarItemsGrid_similarItems$ref = any;
export type PdpRespSimilarItemsFooter_similarGridItems$ref = any;
export type PdpRespSimilarItemsFooter_similarGridItems = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly serviceId: string | null;
            readonly " $fragmentRefs": PdpRespSimilarItemsGrid_similarItems$ref;
        } | null;
    } | null> | null;
    readonly " $refType": PdpRespSimilarItemsFooter_similarGridItems$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSimilarItemsFooter_similarGridItems",
    "type": "moreLikeThisConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "moreLikeThisEdge",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "serviceId",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "PdpRespSimilarItemsGrid_similarItems",
                            "args": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '8f7e0ad5353a169876fb2b4c724c2b9c';
export default node;
